import { isDefined } from "@clipboard-health/util-ts";
import {
  type LatenessConfigEntry,
  type LatenessConfigResponse,
} from "@src/appV2/ClipboardScore/api/useGetClipboardScoreProfile";

/**
 * Finds the lateness config entry whose minutesLateRange contains the given minutes.
 * Entries are sorted by startFrom and the last match (highest startFrom <= latenessMinutes) wins.
 */
export function findLatenessConfigBasedOnMinutesLate(
  minutesLate: number,
  latenessConfig: LatenessConfigResponse
): LatenessConfigEntry | undefined {
  for (const entry of latenessConfig) {
    const { startFrom: minuteRangeFrom, stopAt: minuteRangeTo } = entry.minutesLateRange ?? {};
    if (
      (!isDefined(minuteRangeFrom) || minutesLate >= minuteRangeFrom) &&
      (!isDefined(minuteRangeTo) || minutesLate < minuteRangeTo)
    ) {
      return entry;
    }
  }

  return undefined;
}
